.c1{flex-shrink:0;}